import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";

// components
import { API_STATE } from "~/common/constants/state";
import useRequest from "~/common/hooks/useRequest";
import useAlert from "~/common/hooks/useAlert";

// assets
import "~/assets/sass/pages/applyFormMange/insertApplyForm.scss";
import ViewQna from "./viewComponent/viewQna";
import ViewInquery from "./viewComponent/viewInquery";

const ApplyStartupForm = () => {
	const { t } = useTranslation();
	const params = useParams();
	const listRequest = useRequest("get", "vc/apply/template/" + params.idx);
	const [applyQuestList, setApplyQuestList] = useState([]);
	const [inquiryFinalList, setInquiryFinalList] = useState([]);
	const [isUse, setIsUse] = useState();
	const applyForm = useForm();
	const applyRegRequest = useRequest("post", "/apply/" + params.idx);
	const [showSaveSuccess, SaveSuccess] = useAlert();
	const [showSaveAlert, SaveAlert] = useAlert();
	const [showWarningAlert, Warning] = useAlert();
	const [showEmailWarningAlert, EmailWarning] = useAlert();

	const pattern = new RegExp(
		"^(https?:\\/\\/)" + // protocol
			"((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
			"((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
			"(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
			"(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
			"(\\#[-a-z\\d_]*)?$",
		"i"
	);

	useEffect(() => {
		listRequest.call();
	}, []);

	const submit = (data) => {
		const multiselectArr = data.multiselect;

		const formData = {
			company: {
				name: data.companyName,
				ceo: data.ceoName,
				email: data.ceoEmail,
				country: data.company.country !== "etc" ? data.company.country : data.etcCountry, //기타일 경우 input값을 보내기
				establishedAt: data.esDate,
				investLevel: data.company.investLevel,
				industryField: data.industrytype,
			},
			inputs: inquiryFinalList.map((item, index) => {
				if (item.type === "ADDRESS") {
					return { ...item, answer: `${item.address1}, ${item.address2}` };
				} else if (item.type === "DATE" && item.title !== "설립연월" && !item.answer) {
					// DATE 디폴트값 설정
					return { ...item, answer: new Date() };
				} else if (item.type === "MULTISELECT" && item.title !== "산업분야") {
					const answer = multiselectArr[item.title]
						?.map((val) => val.value)
						.sort()
						.join(",");
					return { ...item, answer: answer };
				} else {
					return { ...item };
				}
			}),
			containInfoContents: true,
		};

		if (
			!inquiryFinalList
				.filter((item) => item.type === "LINK")
				.every((item) => pattern.test(item.answer))
		) {
			showWarningAlert();
			return;
		} else if (
			!formData?.company?.email?.match(
				/^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i
			)
		) {
			showEmailWarningAlert();
			return;
		}

		showSaveAlert().then(() => {
			applyRegRequest.call(formData);
		});
	};

	const setListByTarget = (target) => {
		// 멀티라면, answer에 ,로 구분해서 string으로 집어넣기.
		// console.log(target.type);
		// if (target.type === "CHOICE" && target.answer === "3")
		// 	return setInquiryFinalList(
		// 		inquiryFinalList.map((value) =>
		// 			value.order === target.order ? target : { ...value, answer: "1,3" }
		// 		)
		// 	);
		setInquiryFinalList(
			inquiryFinalList.map((value) => (value.order === target.order ? target : value))
		);
	};

	useEffect(() => {
		switch (listRequest.state) {
			case API_STATE.done:
				const requestApplyList = listRequest.response?.data;
				setApplyQuestList(requestApplyList.template);
				setInquiryFinalList(requestApplyList.template.inputs);
				setIsUse(requestApplyList.template.isUse);
				break;
			default:
				break;
		}
	}, [listRequest.state, listRequest.response]);

	useEffect(() => {
		switch (applyRegRequest.state) {
			case API_STATE.done:
				showSaveSuccess().then(() => window.location.reload());
				break;
			default:
				break;
		}
	}, [applyRegRequest.state, applyRegRequest.response]);

	return (
		<>
			<div className="p__apply-InsertForm">
				{/*empty page */}
				{!isUse ? (
					<div className="page-init">
						<p className="main">현재 투자사는 Apply를 받지않습니다. </p>
						<p className="sub">해당 VC사가 Apply를 활성화하면 신청할 수 있습니다.</p>
					</div>
				) : (
					<div className="apply-form-group">
						{/*	detail page */}
						{applyQuestList?.image?.path && (
							<div className="apply-sticky-card">
								<img src={applyQuestList?.image?.path} alt="기업이미지" />
							</div>
						)}

						{/* apply form */}
						<div className="apply-form-card">
							{applyQuestList.title && (
								<div className="apply-desc-card">
									<h3 className="desc-title">{applyQuestList.title}</h3>
									<div className="divider" />
									{applyQuestList.description && (
										<div className="desc-text">
											{applyQuestList.description.split("\n").map((text) => {
												return <p>{text}</p>;
											})}
										</div>
									)}
								</div>
							)}
							{applyQuestList.qna && applyQuestList.qna.length > 0 && (
								<ViewQna question={applyQuestList.qna} />
							)}

							<ViewInquery
								applyForm={applyForm}
								applyQuestList={applyQuestList.inputs}
								setListByTarget={setListByTarget}
								inquiryFinalList={inquiryFinalList}
								setInquiryFinalList={setInquiryFinalList}
								submit={submit}
							/>
						</div>
					</div>
				)}
			</div>

			<SaveSuccess type="success" message="제출이 완료됐습니다." confirm="확인" />
			<SaveAlert
				type="info"
				message={
					<>
						작성하신
						<br />
						Apply를 제출하시겠습니까?
					</>
				}
				confirm="네"
				reject="아니요"
			/>
			<Warning
				type="info"
				message={t("pages.round.RoundReg.container.RoundRegContainer.warning")}
				subMessage="유효한 링크를 입력해 주세요."
				confirm={t("pages.round.RoundReg.container.RoundRegContainer.confirm")}
			/>
			<EmailWarning
				type="info"
				message={t("pages.round.RoundReg.container.RoundRegContainer.warning")}
				subMessage="이메일 주소를 확인해 주세요."
				confirm={t("pages.round.RoundReg.container.RoundRegContainer.confirm")}
			/>
		</>
	);
};

export default ApplyStartupForm;
